/**
 * V70-A — 게임대회 리더보드 표시 정책
 *   - 공식 리더보드는 Firestore 에 저장된 유효 기록만 표시 (서버 모드)
 *   - 가상·샘플·로컬(브라우저) 기록으로 순위를 채우지 않음
 * V70-C — 1~10위 고정 행 표시 (shared/leaderboardSlots.ts). mock 모드에서는 빈 순위("—")만 표시.
 * V70-D — mock 모드 안내 문구("이 화면에서는 공식 서버 기록을 불러오지 않습니다…")는 사용자 지시로 제거.
 *   관리자 미리보기 안내는 유지.
 */

/** V70-C — 게임대회 OFF 등 일반 직원에게 리더보드가 비공개일 때 system_admin 에게만 보이는 표시 */
export const ADMIN_PREVIEW_LEADERBOARD_NOTICE = '관리자 미리보기 — 현재 일반 직원에게는 리더보드가 공개되지 않습니다.';
